import axiosInstance from './AxiosInstance';

class UserGroupsService {
    constructor() {
        this.endpoint = "/api/groups"
    }

    async getAll() {
        try {
            const response = await axiosInstance.get(this.endpoint);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
    async getAllByGroupName(groupName) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/name/${groupName}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async getByID(id) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async create(data) {
        try {
            const response = await axiosInstance.post(this.endpoint, data);
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }

    async update(data) {
        try {
            const response = await axiosInstance.patch(this.endpoint, data);
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }

    async getModulesAuditByID(id) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/${id}/modules-audit`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
    async deleteSystemGroup(id) {
        try {
            const response = await axiosInstance.delete(`${this.endpoint}/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
}

const userGroupsService = new UserGroupsService();

export { userGroupsService };